import { DocumentList } from '@naf/input';
import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { isNotTransientProp } from '../../lib/shouldForwardProp';

export const StyledDocumentList = styled(DocumentList, { shouldForwardProp: isNotTransientProp })<{
  $hasFiles: boolean;
}>`
  margin-bottom: ${({ $hasFiles }) => ($hasFiles ? `calc(-1 * ${spacing.space12})` : spacing.space8)};

  ul > p {
    font-weight: 500;
  }
`;

export const FileDropWrapper = styled.div<{ $extraMargin?: boolean; $hasFiles?: boolean }>`
  margin-bottom: ${({ $extraMargin }) => $extraMargin && spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    margin-bottom: ${({ $extraMargin }) => ($extraMargin ? spacing.space64 : spacing.space32)};
  }
`;
